import { GenericDialog, IGenericDialogButton } from '@AMIEWEB/Alerts/GenericDialog';
import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

export interface IConfirmationDialogProps {
  dialogeOpen: boolean;
  handleCancel?: () => void;
  handleInheritPublish?: () => void;
  handlePublish?: () => void;
  handleReject?: () => void;
  handleAccepet?: () => void;
  dialogActions?: IGenericDialogButton[];
  isInheritPublish?: boolean;
  isInheritCancel?: boolean;
  isPublish?: boolean;
  isReject?: boolean;
  isAccept?: boolean;
  dialogeText_1?: string;
  dialogeText_2?: string;
  headerText?: string;
}

const useStyles = makeStyles<{ isAccept: boolean }>()((theme, { isAccept = false }) => ({
  dialog: {
    top: 0,
    marginBottom: '20px',
    '& .MuiDialog-paperWidthSm': {
      width: !isAccept ? '390px' : '429px',
      maxWidth: '460px',
      minHeight: !isAccept ? '264px' : '198px',
    },
    '& .MuiDialogActions-root': {
      padding: !isAccept ? '12px 30px 30px' : '0px 15px 30px 15px'
    }
  },
  dialogueContent: {
    margin: '0px 32px 1px 32px',
    fontSize: '14px',
    padding: 0,
    '& .MuiDialogContent-root': {
      padding: 0,
    },
    '& .dialogContentRoot': {
      padding: 0,
    },
  },
  dialogeText: {
    marginTop: '14px',
  },
}));

const InheritUnitPreferenceDialog = ({
  dialogeOpen,
  handleInheritPublish,
  handleCancel,
  handlePublish,
  handleReject,
  handleAccepet,
  isInheritPublish,
  isInheritCancel,
  isPublish,
  isReject,
  isAccept,
  dialogeText_1,
  dialogeText_2,
  headerText
}: IConfirmationDialogProps) => {
  const { t } = useTranslation();
  const { classes } = useStyles({ isAccept });

  return (
    <div>
      <GenericDialog
        open={dialogeOpen}
        className={classes.dialog}
        dialogTitleProps={{
          text: t(`autoTaskManagement.dialogModal.dialogPrefrenceModalHeader`),
        }}
        dialogContentProps={{
          classes: {
            root: classes.dialogueContent,
          },
        }}
        disableEscapeKeyDown
        dialogActions={[
          {
            onClick: handleCancel,
            text: 'close',
            hidden: isInheritCancel,
          },
          {
            onClick: handlePublish,
            text: t('PUBLISH'),
            variant: 'contained',
            hidden: isPublish,
          },
          {
            onClick: handleInheritPublish,
            text: t('INHERIT AND PUBLISH'),
            variant: 'contained',
            hidden: isInheritPublish,
          },
          {
            onClick: handleReject,
            text: t('NOT NOW'),
            hidden: isReject,
          },
          {
            onClick: handleAccepet,
            text: t('ACCEPT'),
            variant: 'contained',
            hidden: isAccept,
          },
        ]}
      >
        <Typography>{dialogeText_1}</Typography>
        <Typography className={classes.dialogeText}>{dialogeText_2}</Typography>
      </GenericDialog>
    </div>
  );
};

export default InheritUnitPreferenceDialog;
